module.exports = __webpack_public_path__ + "img/game_main_pc_263_off.51ef81da.png";